module.exports = __webpack_public_path__ + "img/ClickForSound_24.d246c71c.png";